import { render, staticRenderFns } from "./ItfPrint.vue?vue&type=template&id=400150a6"
import script from "./ItfPrint.vue?vue&type=script&lang=js"
export * from "./ItfPrint.vue?vue&type=script&lang=js"
import style0 from "./ItfPrint.vue?vue&type=style&index=0&id=400150a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports